import { registerComponent } from './components-front'

registerComponent('archive', _ => {
    $(document).on("click", '.cat-accordion-header:not(.cat-link)', function() {
        const parent = $(this).closest(".cat-accordion-item");
        parent.siblings().removeClass("active");
        parent.toggleClass("active");
    });
}, false)